import Vue from 'vue';
export const FilledShoppingCartIcon = Vue.extend({
    functional: true,
    name: 'FilledShoppingCartIcon',
    props: {
        itemCount: Number,
    },
    render(createElement, ctx) {
        return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                <defs>
                    <clipPath id="clip-path">
                        <rect fill="none" x="11" y="12" width="28.31" height="26" id="rect4"/>
                    </clipPath>
                </defs>
                <rect fill="red" width="50" height="50"/>
                <path fill="#212630" 
        // tslint:disable-next-line: max-line-length
        d="m 24.085188,26.890208 v 11.510883 l -9.996293,-4.119685 v -6.555144 l 7.270031,3.004946 z m 1.829624,0 2.677795,3.841 7.270031,-3.004946 v 6.555144 l -9.996292,4.119685 z m -15.267065,-2.568744 2.859546,-4.095451 10.093226,4.168151 -2.859545,4.095451 z m 15.751734,0.0727 10.093227,-4.168151 2.859545,4.095451 -10.093226,4.168151 z m -13.934226,-5.864492 -4.61647,6.615728 4.410486,1.817508 v 8.481703 l 12.734671,5.307123 12.734671,-5.258656 v -8.481703 l 4.422602,-1.817508 -4.907271,-7.01558 -4.265085,-2.084075 -1.684224,1.211672 3.489615,1.635757 -9.790308,4.046984 -9.790309,-4.046984 3.550199,-1.684224 -1.672107,-1.211672 z" style="fill:#212630;stroke-width:1.21167183"/>
                <g transform="translate(25,12)">
                    <circle cx="0" cy="0" fill="#fff" r="10"/>
                    <text stroke-width="0" text-anchor="middle" x="0" y="5" style={{
            fontSize: calculateFontSize(ctx.props.itemCount),
        }}>
                        {displayItemCount(ctx.props.itemCount)}
                    </text>
                </g>
            </svg>);
    },
});
function displayItemCount(itemCount) {
    return itemCount > 99 ? '99+' : String(itemCount);
}
function calculateFontSize(itemCountString) {
    const length = displayItemCount(itemCountString).length;
    switch (length) {
        case 1:
            return '18px';
        case 2:
            return '14px';
        default:
            return '12px';
    }
}
//# sourceMappingURL=FilledShoppingCartIcon.jsx.map